import {gql} from '@apollo/client';

export const QUERY_ORDER = gql`
    query GetMoneyWwOrder ($UID: ID, $token: String!) {
        GetMoneyWwOrder(UID: $UID, token: $token) {
            status
        }
    }
`